/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './communication.dto';
export * from './communication.mapper';
export * from './communication-rest.service';
